import { Hero8Pilares } from "@/components/metodolda/Hero";
import { VSLSection } from "@/components/VSLSection";
import { Benefits } from "@/components/metodolda/Benefits";
import { Transformation } from "@/components/metodolda/Transformation";
import { Testimonials } from "@/components/Testimonials";
import { FAQ } from "@/components/FAQ";
import { Footer } from "@/components/Footer";
import CTA from "@/components/metodolda/CTA";
import { Warranty } from "@/components/metodolda/Warranty";
import { Persona } from "@/components/metodolda/Persona";
import { QUIZ_TIMERS } from "@/config/constants";
import { useState, useEffect, useRef } from "react";
import { UpsellModuloLda } from "@/components/upsell/UpsellModuloLda";

const Index = () => {
  const [showContent, setShowContent] = useState(false);
  const [upsellType, setUpsellType] = useState<string | null>(null);
  const ctaRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Verificar se há parâmetro de upsell na URL
    const searchParams = new URLSearchParams(window.location.search);
    const upsellParam = searchParams.get("upsell");
    if (upsellParam) {
      setUpsellType(upsellParam);
      return; // Não iniciar timer se for upsell
    }

    // Mostrar conteúdo após 11 minutos
    const timer = setTimeout(() => {
      setShowContent(true);
    }, QUIZ_TIMERS.product_page_metodolda);
    return () => clearTimeout(timer);
  }, []);

  const handleScrollToCTA = () => {
    ctaRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  // Se tiver upsell, renderizar a página de upsell correspondente
  if (upsellType === "modulo") {
    return <UpsellModuloLda />;
  }

  return (
    <div className="min-h-screen bg-background text-foreground overflow-hidden">
      <Hero8Pilares onCtaClick={handleScrollToCTA} />
      {showContent && (
        <>
          <Transformation />
          <Testimonials />
          {/* <VSLSection /> */}
          <Benefits />
          <div ref={ctaRef}>
            <CTA />
          </div>
          <Warranty />
          <Persona />
          <Footer />
        </>
      )}
    </div>
  );
};

export default Index;
